import React, { useRef, useState, useEffect } from "react";
import { Col, Row, Button } from "antd";
import bg1 from "../pics/bg02.jpg";

const Research_login_cmu = () => {
  const textRef = useRef(null);
  const [buttonWidth, setButtonWidth] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // วัดความกว้างข้อความและปรับเมื่อหน้าต่างเปลี่ยน
  useEffect(
    () => {
      const updateWidth = () => setWindowWidth(window.innerWidth);

      window.addEventListener("resize", updateWidth);
      if (textRef.current) setButtonWidth(textRef.current.offsetWidth);

      return () => window.removeEventListener("resize", updateWidth);
    },
    [windowWidth]
  );

  // ปรับขนาด font ตามหน้าจอ
  const getFontSize = () => {
    if (windowWidth < 576) return "2rem"; // xs
    if (windowWidth < 768) return "3rem"; // sm
    if (windowWidth < 992) return "3.5rem"; // md
    return "4rem"; // lg+
  };

  const leftColStyle = {
    backgroundImage: `url(${bg1})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    fontWeight: "bold",
    minHeight: "50vh",
    fontSize: windowWidth < 576 ? "1.5rem" : "2rem",
    textAlign: "center"
  };

  const rightColStyle = {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    padding: "2rem",
    minHeight: "50vh"
  };

  const blurBgStyle = {
    backgroundImage: `url(${bg1})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    filter: "blur(8px)",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 1
  };

  const textStyle = {
    position: "relative",
    zIndex: 2,
    fontSize: getFontSize(),
    fontWeight: "bold",
    background:
      "linear-gradient(90deg, #ffe0e1ff, #fad0c4, #fbc2eb, #a6c1ee, #f6d365)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    textShadow: "2px 2px 2px rgba(21, 153, 9, 1)",
    marginBottom: "1.5rem",
    textAlign: "center"
  };

  const buttonStyle = {
    position: "relative",
    zIndex: 2,
    width: `${buttonWidth}px`,
    height: "45px",
    fontSize: windowWidth < 576 ? "0.9rem" : "1rem",
    fontWeight: "bold",
    color: "white",
    background: "linear-gradient(90deg, #6a11cb, #2575fc)",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease"
  };

  const clientId = process.env.REACT_APP_CLIENT_ID;
  const redirectUri = process.env.REACT_APP_REDIRECT_URI;
  const tenantId = process.env.REACT_APP_TENANT_ID;
  const scope = process.env.REACT_APP_SCOPE;

  const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(
    redirectUri
  )}&response_mode=query&scope=${encodeURIComponent(scope)}`;

  return (
    <Row gutter={[0, 0]}>
      <Col xs={24} md={12} style={{ ...leftColStyle, height: "100vh" }} />
      <Col xs={24} md={12} style={{ ...rightColStyle, height: "100vh" }}>
        <div style={blurBgStyle} />
        <h1 ref={textRef} style={textStyle}>
          RESEARCH RIHES
        </h1>
        <Button
          className="login-button"
          style={buttonStyle}
          onMouseEnter={e => (e.currentTarget.style.filter = "brightness(1.1)")}
          onMouseLeave={e => (e.currentTarget.style.filter = "brightness(1)")}
          onClick={() => (window.location.href = authUrl)}
        >
          SIGN IN WITH CMU ACCOUNT
        </Button>
      </Col>
    </Row>
  );
};

export default Research_login_cmu;
